export default [
  {
    component: 'CNavTitle',
    name: 'Dashboard',
  },
  {
    component: 'CNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'cil-speedometer',
  },
  {
    component: 'CNavTitle',
    name: 'Modulos',
  },
  {
    component: 'CNavGroup',
    name: 'Modulos',
    icon: 'cil-browser',
    items: [
      {
        component: 'CNavItem',
        name: 'Apostas Feitas',
        icon: 'cil-browser',
        to: '/LogBancasPremios',
      },
      {
        component: 'CNavItem',
        name: 'Whatsapp Notification',
        icon: 'cil-browser',
        to: '/WhatsappNotification',
      },
      {
        component: 'CNavItem',
        name: 'Monitor Campanhas WhatsApp',
        icon: 'cil-browser',
        to: '/WhatsappCampaignMonitor',
      },
      {
        component: 'CNavItem',
        name: 'Todos | Links Ads',
        icon: 'cil-browser',
        to: '/LinksAdsNew',
      },
      {
        component: 'CNavItem',
        name: 'Relatório de Vendas Semanais',
        icon: 'cil-browser',
        to: '/RelatorioVendasSemanais',
      },
      {
        component: 'CNavItem',
        name: 'Análise de Faturamento',
        icon: 'cil-browser',
        to: '/Faturamento',
      },
      {
        component: 'CNavItem',
        name: 'Metas e Vendas',
        icon: 'cil-browser',
        to: '/MetasVendas',
      },
      {
        component: 'CNavItem',
        name: 'Consultores (exportação)',
        icon: 'cil-browser',
        to: '/ConsultoresExport',
      },
      {
        component: 'CNavItem',
        name: 'Relatório de Depósitos Semanais',
        icon: 'cil-browser',
        to: '/RelatorioDepositosSemanais',
      },
      {
        component: 'CNavItem',
        name: 'Compradores de combo',
        icon: 'cil-browser',
        to: '/ComboBuyersReport',
      },
      {
        component: 'CNavItem',
        name: 'Entrega Plano de Carreira',
        icon: 'cil-gift',
        to: '/EntregaPlanoCarreira',
      },
      {
        component: 'CNavItem',
        name: 'Bloquear Consultores',
        icon: 'cil-browser',
        to: '/Consultores',
      },
      {
        component: 'CNavItem',
        name: 'Transferência de Usuários',
        icon: 'cil-swap-horizontal',
        to: '/transferencia-usuarios',
      },
    ],
  },
  {
    component: 'CNavGroup',
    name: 'Layout',
    icon: 'cil-browser',
    items: [
      {
        component: 'CNavItem',
        name: 'Icones SideBar',
        icon: 'cil-browser',
        to: '/layput/sidebar',
      },
      {
        component: 'CNavItem',
        name: 'Cores Site',
        icon: 'cil-browser',
        to: '/layput/corsite',
      },
      {
        component: 'CNavItem',
        name: 'BtnHome',
        icon: 'cil-browser',
        to: '/layput/btnhome',
      },
    ],
  },
  {
    component: 'CNavTitle',
    name: 'Usuários',
  },
  {
    component: 'CNavItem',
    name: 'Usuários',
    to: '/usuarios',
    icon: 'cil-user',
  },
]
